export enum StorageLocationType {
  Bin = "bin",
  Tote = "tote",
  Storage = "storage",
  Receiving = "receiving",
  External = "external",
  Lost = "lost",
  Transit = "transit",
  Unmapped = "unmapped",
  Default = "default",
  Waste = "waste",
  Flush = "flush",
  Station = "station",
  SortingTote = "sorting_tote",
  Staging = "staging",
  Supplies = "supplies",
}
